import React from 'react';
import { shallow } from 'zustand/shallow';
import useMapStore from '@store/useMapStore';
import { TILE_SIZE, EMPTY_ARRAY } from '@utils/constants';
import { handleTileClick } from '@services/mapService';
import './HighlightLayer.css';
// No necesitamos 'feedback' si solo usaremos console.warn, para mantenerlo simple.

const HighlightLayer = () => {
  const highlightTiles = useMapStore((state) => state.visual?.highlightTiles, shallow) || EMPTY_ARRAY;

  if (!Array.isArray(highlightTiles)) {
    // 👇 ADVERTENCIA AÑADIDA
    console.warn(
      '[HighlightLayer] Dato de highlightTiles inválido. Se esperaba un array pero se recibió:',
      highlightTiles
    );
    return null; 
  }

  if (highlightTiles.length === 0) {
    // Esta es una salida normal, no necesita advertencia.
    return null;
  }

  return (
    <div className="map-layer highlight-layer">
      {highlightTiles.map((tile, index) => {
        // 👇 VALIDACIÓN Y ADVERTENCIA DENTRO DEL MAP
        if (!tile || typeof tile.x !== 'number' || typeof tile.y !== 'number') {
          console.warn(`[HighlightLayer] Se encontró un objeto de tile inválido en el índice ${index}:`, tile);
          return null; // Omitimos el renderizado de este tile inválido
        }

        const style = {
          left: `${tile.x * TILE_SIZE}px`,
          top: `${tile.y * TILE_SIZE}px`,
          width: `${TILE_SIZE}px`,
          height: `${TILE_SIZE}px`,
        };

        return (
          <div
            key={`highlight-${tile.x}-${tile.y}-${index}`}
            className="highlight-tile"
            style={style}
            data-type={tile.type || 'generic'}
            onClick={() => handleTileClick(tile.x, tile.y, null)} 
          />
        );
      })}
    </div>
  );
};

export default React.memo(HighlightLayer);